import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

import ColorSwatch from './ColorSwatch';
import '../global-sass/main.scss';

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const numberWithCommas = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const renderSpecs = (
	{
		bodyStyle,
		cityFuelEconomy,
		driveLine,
		engine,
		engineSize,
		exteriorColor,
		normalExteriorColor,
		highwayFuelEconomy,
		interiorColor,
		normalInteriorColor,
		maxSeatingCapacity,
		odometer,
		transmission
	},
	deviceType,
	labels,
	vehicleType
) => {
	// Not showing the odometer field when vehicle type is 'NEW'
	const odometerValue =
		odometer &&
		vehicleType !== 'NEW' &&
		`${numberWithCommas(odometer)} ${labels.get('MILES_KILOMETERS')}`;

	const fuelEconomyValue =
		cityFuelEconomy &&
		highwayFuelEconomy &&
		`${cityFuelEconomy.toFixed(1)}/${highwayFuelEconomy.toFixed(
			1
		)} ${labels.get('MPG_CITY_HWY')}`;

	const extColorText = exteriorColor || normalExteriorColor;
	const intColorText = interiorColor || normalInteriorColor;

	const swatchDeviceClass =
		deviceType === 'MOBILE' ? 'swatch-mobile' : 'swatch-desktop';

	const extColorSwatch = (
		<ColorSwatch
			normalizedColor={normalExteriorColor}
			fullColor={exteriorColor}
			swatchDeviceClass={swatchDeviceClass}
		/>
	);

	const intColorSwatch = (
		<ColorSwatch
			normalizedColor={normalInteriorColor}
			fullColor={interiorColor}
			swatchDeviceClass={swatchDeviceClass}
		/>
	);

	let bodySeatingKey;
	let bodySeatingValue;
	if (bodyStyle && maxSeatingCapacity) {
		bodySeatingKey = labels.get('BODY_SEATING');
		bodySeatingValue = `${bodyStyle}/${maxSeatingCapacity} ${labels.get(
			'SEATS'
		)}`;
	} else if (bodyStyle) {
		bodySeatingKey = labels.get('BODY');
		bodySeatingValue = bodyStyle;
	} else if (maxSeatingCapacity) {
		bodySeatingKey = labels.get('SEATING');
		bodySeatingValue = `${maxSeatingCapacity} ${labels.get('SEATS')}`;
	}

	let engineValue;
	if (engineSize && engine) {
		engineValue = `${engineSize} ${engine}`;
	} else if (engine) {
		engineValue = engine;
	} else if (engineSize) {
		engineValue = engineSize;
	}

	const specObj = {
		[labels.get('ODOMETER')]: odometerValue,
		[labels.get('FUEL_ECONOMY')]: fuelEconomyValue,
		[labels.get('EXTERIOR_COLOR')]: extColorText,
		[labels.get('INTERIOR_COLOR')]: intColorText,
		[bodySeatingKey]: bodySeatingValue,
		[labels.get('TRANSMISSION')]: transmission,
		[labels.get('DRIVETRAIN')]: driveLine,
		[labels.get('ENGINE')]: engineValue
	};

	const popoverPlacement = deviceType === 'MOBILE' ? 'top' : 'right';

	const popoverHoverFocus = (
		<Popover id="quick-specs-popover">
			{labels.get('MPG_ESTIMATE_DISCLAIMER')}
		</Popover>
	);

	return Object.keys(specObj)
		.filter(key => specObj[key]) // remove keys that don't have a value
		.map(key => {
			if (key === labels.get('FUEL_ECONOMY')) {
				return [
					<dt key={`${key}_name`} className="text-muted col-xs-5">
						<OverlayTrigger
							trigger={['hover', 'focus']}
							placement={popoverPlacement}
							overlay={popoverHoverFocus}
						>
							<span>
								{key}
								<i className="ddc-icon ddc-icon-info text-muted ddc-icon-size-small d-inline-block pl-1" />
							</span>
						</OverlayTrigger>
					</dt>,
					<dd key={`${key}_val`} className="pl-1 col-xs-7">
						<span>{specObj[key]}</span>
					</dd>
				];
			}
			return [
				<dt key={`${key}_name`} className="text-muted col-xs-5">
					{key}
				</dt>,
				<dd key={`${key}_val`} className="pl-1 col-xs-7">
					{key === labels.get('EXTERIOR_COLOR') && extColorSwatch}
					{key === labels.get('INTERIOR_COLOR') && intColorSwatch}
					<span className="d-inline-block">{specObj[key]}</span>
				</dd>
			];
		});
};

export default class QuickSpecs extends Component {
	render() {
		const { quickSpecs, vehicleType, deviceType, labels } = this.props;

		if (
			Object.keys(quickSpecs).length === 0 &&
			quickSpecs.constructor === Object
		) {
			return null;
		}

		return (
			<dl className="line-height-condensed dl-horizontal row list-spaced">
				{renderSpecs(quickSpecs, deviceType, labels, vehicleType)}
			</dl>
		);
	}
}

QuickSpecs.propTypes = {
	// shape of quickSpecs is dynamic so can't give it a 'shape'
	quickSpecs: PropTypes.object /* eslint react/forbid-prop-types: 0 */,
	deviceType: PropTypes.string.isRequired,
	labels: PropTypes.object.isRequired,
	vehicleType: PropTypes.string
};

QuickSpecs.defaultProps = {
	quickSpecs: {},
	vehicleType: ''
};



// WEBPACK FOOTER //
// ./src/components/QuickSpecs.jsx